import React, {useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import CustomButton from '../../../commonComponents/CustomButton';
import {Network} from '../../../utils/network';
import ClubImageCard from './clubImageCard';

const ClubOptionsSettle = ({
  orderStatus,
  clubEventDetails,
  onDifferentOptions,
  optionSelectedIndex,
}) => {
  const optionSelected =
    clubEventDetails && clubEventDetails?.options[optionSelectedIndex];

  const onPlaceOrder = async () => {
    let res = await Network.settleClub(
      {
        id: +clubEventDetails?.id,
        status: 'C',
        correct_value: optionSelected?.id,
      },
      true,
    );
    res = {...res?.data, isSettlement: true};

    orderStatus({orderResponse: res});
  };
  return (
    <View style={{marginVertical: 10}}>
      <ClubImageCard
        isForm={true}
        title={clubEventDetails?.title}
        titleImg={clubEventDetails?.image_url}
      />
      <Text style={[globalFontStyle.appFontSmallText, {marginTop: 30}]}>
        You have selected
      </Text>
      <View style={{marginBottom: 34, flexDirection: 'row'}}>
        <Text
          style={[
            globalFontStyle.appFontTitle,
            {color: Color.black, marginRight: 5},
          ]}>
          {optionSelected?.label}
        </Text>
        <TouchableOpacity
          onPress={() => {
            orderStatus({isEdit: true});
          }}
          style={{marginTop: 8}}>
          <Text
            style={[globalFontStyle.appFontSmallText, {color: Color.blue1}]}>
            Edit
          </Text>
        </TouchableOpacity>
      </View>
      <CustomButton
        btnText={'Confirm'}
        btnType="normalBlue"
        onBtnClick={onPlaceOrder}
      />
      <CustomButton />
    </View>
  );
};

export default ClubOptionsSettle;
